// The Content-Security-Policy of the production build (§11 M11, injected by vite.config.ts). M15 (owner
// override O4): `connect-src` allows exactly the two AI providers' API hosts besides 'self', and the app only
// calls them after the user has pasted a key (src/features/ai/). Nothing else can be reached.
export const AI_HOSTS = ['https://api.openai.com', 'https://generativelanguage.googleapis.com'] as const;

export const CSP = [
  "default-src 'self'",
  "script-src 'self' 'wasm-unsafe-eval'",
  "worker-src 'self' blob:",
  "img-src 'self' blob: data:",
  `connect-src 'self' ${AI_HOSTS.join(' ')}`,
  "style-src 'self' 'unsafe-inline'",
].join('; ');
